/**
 * Shared company types for API contracts between frontend and backend
 */
import { z } from "zod";
// ============================================
// Input Schemas
// ============================================
export const CreateCompanyInputSchema = z.object({
    name: z.string().min(1).max(255),
});
export const UpdateCompanyInputSchema = z.object({
    name: z.string().min(1).max(255).optional(),
});
export const OnboardCompanyInputSchema = z.object({
    name: z.string().min(1).max(255),
    ownerId: z.string().uuid(),
});
// ============================================
// Response Schemas
// ============================================
export const CompanyResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const EmploymentResponseSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    companyId: z.string().uuid(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const CompanyWithOwnerResponseSchema = z.object({
    company: CompanyResponseSchema,
    employment: EmploymentResponseSchema,
});
export const LocationLevelSchema = z.object({
    id: z.string(),
    label: z.string(),
    enabled: z.boolean(),
    required: z.boolean().optional(),
});
export const LocationInStructureSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    addressLine1: z.string(),
    addressLine2: z.string().nullable(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
    country: z.string(),
    phone: z.string().nullable(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    companyId: z.string().uuid(),
});
export const CorporateStructureResponseSchema = z.object({
    levels: z.array(LocationLevelSchema),
    regions: z.array(z.any()),
    storeLocations: z.array(LocationInStructureSchema),
    departments: z.array(z.any()),
});
